import React, { useState } from "react";

import Modal from "react-modal";
import axios from "axios";

import { Button } from "../ui";
import { ImageCrop } from "../inputs";
import { getFileUrl, getApiUrl } from "../../core/config/api.js";

try {
  Modal.setAppElement("#app");
} catch (e) {
  console.error(e);
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    padding: "0",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const buildFileSrc = (fileId) => getFileUrl(fileId);

const ImageUploadModal = ({
  defaultSrc = null,
  open,
  onSetFile,
  closeModal,
  modalProps,
}) => {
  const [src, setSrc] = useState(defaultSrc);
  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onCrop = (base64) => setImage(base64);

  const onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].size > 7340032) {
      alert("The image is too big! 7MB is the maximum size.");
      elem.target.value = "";
    }
  };

  const onSubmit = async () => {
    if (image) {
      setSubmitting(true);
      const { data } = await axios.post(getApiUrl("/api/files"), { base64: image });
      setSubmitting(false);

      onSetFile(data);
      setSrc(buildFileSrc(data.id));
    } else {
      onSetFile(null);
    }
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="content">
        <p>{modalProps.title}</p>

        <ImageCrop
          exportAsSquare={true}
          onCrop={onCrop}
          setImage={setImage}
          onBeforeFileLoad={onBeforeFileLoad}
          src={src}
        />
      </div>

      <div className="actions">
        {/* Deliberately a button under the RC no-Save rule (M56B): cropping
            is a local adjustment, and this click is the TRANSACTION — it
            uploads the cropped file (POST /api/files) and attaches it.
            Auto-uploading on every crop drag would write a file per nudge. */}
        <Button variant="primary" size="lg" loading={submitting} onClick={onSubmit}>
          Save
        </Button>
      </div>

      {modalProps?.note && (
        <div style={{ width: "350px" }} className="m-4">
          <h4>{modalProps.note.title}</h4>
          <p style={{ whiteSpace: "pre-wrap" }}>
            {modalProps.note.description}
          </p>
        </div>
      )}
    </Modal>
  );
};

export default ImageUploadModal;
